import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StatsBar } from './components/sections/StatsBar';
import { ProblemSection } from './components/sections/ProblemSection';
import { DifferenceSection } from './components/sections/DifferenceSection';
import { HowItWorks } from './components/sections/HowItWorks';
import { ImagineSection } from './components/sections/ImagineSection';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusSection } from './components/sections/BonusSection';
import { OfferSection } from './components/sections/OfferSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { AboutSection } from './components/sections/AboutSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="682rygdekbl">
      <MetaPixel data-id="element-1" data-mp="56qxrrj5tst" />
      <Hero data-id="element-2" data-mp="7sxpp6lk59z" />
      <main data-id="element-3" data-mp="2zld2xbxu5jcl">
        <StatsBar data-id="element-4" data-mp="2zllijblcf2rh" />
        <ProblemSection data-id="element-5" data-mp="2zmepodo7rua5" />
        <DifferenceSection data-id="element-6" data-mp="2zmwh8wzxlkbq" />
        <HowItWorks data-id="element-7" data-mp="33mowfsjtyoq2" />
        <ImagineSection data-id="element-8" data-mp="33lwxq8uxsavk" />
        <BeforeAfter data-id="element-9" data-mp="33ngfy505kvzz" />
        <PainPoints data-id="element-10" data-mp="33orhrza1ftog" />
        <VolumesSection data-id="element-11" data-mp="38lrq6gud18iq" />
        <BonusSection data-id="element-12" data-mp="38li95irambp6" />
        <OfferSection data-id="element-13" data-mp="38l06o4e1f18t" />
        <GuaranteeSection data-id="element-14" data-mp="38nup5qdhqbzl" />
        <TestimonialsSection data-id="element-15" data-mp="3dkl3o99ncziw" />
        <AboutSection data-id="element-16" data-mp="3dlw6a5rcw18f" />
        <FaqSection data-id="element-17" data-mp="3dmfozootytni" />
        <FinalCTA data-id="element-18" data-mp="3dii3iwes5q0g" />
      </main>
      <Footer data-id="element-19" data-mp="nw2ak1lu1ioz" />
      <FloatingCTA data-id="element-20" data-mp="nuhg0bzipzr4" />
      <PurchasePopup data-id="element-21" data-mp="nv0ybtt2yq5o" />
    </div>;
}